import React from "react";
import { HelmetProvider } from "react-helmet-async";
import TurnoutMap from "./components/Map";
import "./styles/app.scss";
// import { Header } from "./components/HeaderFooter";


export const App = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const embedParam = queryParams.get("embed");
  return (
    <HelmetProvider>
      {!!embedParam ? (
        <div className="app">
          <TurnoutMap />
        </div>
      ) : (
        <article>
          {/* <Header /> */}
          <div className="app">
            <div className="container">
            </div>

            <div className="copy-container">
              <div className="copy">
                <TurnoutMap />
              </div>
            </div>

          </div>
        </article>
      )}
    </HelmetProvider>
  );
};
